import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import React, { ComponentType } from "react";
import PageLoader from "../PageLoader/PageLoader";
import { Box, styled, Typography } from "@mui/material";

const NO_PERMISSION_TEXT = "Ups... parece que no tienes permisos para acceder a esta página.";

const CenteredContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
});

const NoPermissionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
}));

const PageLayoutWrapper = styled(Box)({
  className: "page-layout",
});

interface AdminGuardProps {
  component: ComponentType;
}

export const AdminGuard: React.FC<AdminGuardProps> = ({ component }) => {
  const { user } = useAuth0();
  if (user) {
    const isAdmin =
      user.user_roles && Array.isArray(user.user_roles) && user.user_roles.includes("admin");
    if (!isAdmin) {
      return (
        <CenteredContainer>
          <NoPermissionText variant="h2" gutterBottom>
            {NO_PERMISSION_TEXT}
          </NoPermissionText>
        </CenteredContainer>
      );
    }
  }

  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <PageLayoutWrapper className="page-layout">
        <PageLoader />
      </PageLayoutWrapper>
    ),
  });

  return <Component />;
};
